import React, { Fragment } from 'react';
import { TABLE_GROUP } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/table';
import NowLine from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/now';
import ReleaseBar from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/release-bar';
import TimelineReleaseMarker from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/release-bar/timeline-marker';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import { GROUPING } from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import Capacities from '../capacities';
import { Overflowed as RowOverflowed } from '../row';
import Sprints from '../sprints';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

export default function TableGroup({
	item,
	showCapacity,
	timelineRange,
	zoomLevel,
	width,
	style,
	key = '',
}: Props) {
	if (!isDefined(item)) return null;
	if (item.tag !== TABLE_GROUP) {
		throw new Error(`renderGroup could only render ${TABLE_GROUP} items, but got ${item.tag}`);
	}
	const { group, grouping } = item;
	const [Overflowed, Restored] = !zoomLevel
		? [Fragment, Fragment]
		: [RowOverflowed, RowOverflowed.Restore];

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
		<div key={`${item.tag}-${group || key || ''}`} style={style}>
			<Overflowed>
				{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
				<div className={styles.content}>
					<Restored>
						{showCapacity &&
							grouping === GROUPING.TEAM &&
							isDefined(item.groupCombination.team) && (
								<Sprints team={item.groupCombination.team} timelineRange={timelineRange} />
							)}
						{showCapacity &&
							grouping === GROUPING.SPRINT &&
							isDefined(item.groupCombination.team) &&
							isDefined(item.groupCombination.sprint) && (
								<Capacities
									team={item.groupCombination.team}
									sprint={item.groupCombination.sprint}
									timelineRange={timelineRange}
								/>
							)}
						<NowLine noMarker />
						<ReleaseBar
							width={width}
							renderMarker={({ date, mode, versionIdsMapByDate }) => (
								<TimelineReleaseMarker
									key={date}
									endDate={date}
									mode={mode}
									versionIdsMapByDate={versionIdsMapByDate}
								/>
							)}
						/>
					</Restored>
				</div>
			</Overflowed>
		</div>
	);
}
